import usePrivateAxios from "@/common/api/usePrivateAxios"
import { MaintenanceSpecificationValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { useMutation } from "@tanstack/react-query"
import { EstablishmentLeadData } from "../../types/establishmentLead.type";
import { getRailsUpdate } from "@/common/utils/getRailsUpdate";
import { mapToDeletion } from "@/common/utils/railsHelpers";

interface UseUpdateEstablishmentLeadMaintenanceSpecificationProps {
  establishmentLeadId: string;
  maintenanceSpecification: EstablishmentLeadData['maintenance_specifications'][number];
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const useUpdateEstablishmentLeadMaintenanceSpecification = ({
  establishmentLeadId,
  maintenanceSpecification,
  onSuccess,
  onError,
}: UseUpdateEstablishmentLeadMaintenanceSpecificationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentLeadMaintenanceSpecification'],
    mutationFn: (data: MaintenanceSpecificationValidationSchema) => {
      const payload = {
        maintenance_specifications_attributes: [
          {
            id: maintenanceSpecification.id,
            equipment_category_specifications_attributes: getRailsUpdate(
              maintenanceSpecification.equipment_category_specifications || [],
              data.equipment_category_specifications_attributes || [],
              (x) => x.category_id,
              (y) => y.value,
              mapToDeletion,
              (z) => ({ category_id: z.value }),
            ),
            equipment_manufacturer_specifications_attributes: getRailsUpdate(
              maintenanceSpecification.equipment_manufacturer_specifications || [],
              data.equipment_manufacturer_specifications_attributes || [],
              (x) => x.manufacturer.id,
              (y) => y.value,
              mapToDeletion,
              (z) => ({ manufacturer_id: z.value }),
            ),
            system_specifications_attributes: getRailsUpdate(
              maintenanceSpecification.system_specifications || [],
              data.system_specifications_attributes || [],
              (x) => x.system_id,
              (y) => y.value,
              mapToDeletion,
              (z) => ({ system_id: z.value }),
            ),
          },
        ],
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}/update_maintenance_models`, {
        lead: payload,
      });
    },
    onSuccess,
    onError,
  })
}
